import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationStart, RouteConfigLoadEnd, Router } from '@angular/router';
import { NgEventBus } from 'ng-event-bus';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AttachmentsDataService } from 'src/app/attachments/attachments-data.service';
import { AttachmentsService } from 'src/app/attachments/attachments.service';
import { LoginService } from 'src/app/login/login.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { OrganizationsContactsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/organizations-contacts-detail.component';
import { OrganizationsDetailGeneralComponent } from 'src/app/organizations/organizations-detail/organizations-detail-general/organizations-detail-general.component';
import { OrganizationsQuickComponent } from 'src/app/organizations/organizations-quick/organizations-quick/organizations-quick.component';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { TasksDetailComponent } from 'src/app/tasks/tasks-detail/tasks-detail.component';
import { TransactionsDetailComponent } from 'src/app/transactions/transactions-detail/transactions-detail.component';
import { UserChangePasswordComponent } from 'src/app/users/user-change-password/user-change-password.component';
import { UsersService } from 'src/app/users/users.service';
import { CompaniesService } from '../../companies/companies.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { EntitiesService } from '../../configuration/entities.service';
import { UsersDetailComponent } from '../../users/users-detail/users-detail.component';
import { CoreDialogService } from '../dialogs/core-dialog.service';
import { SearchService } from '../search.service';
import { NewViewComponent } from '../view/component/new-view/new-view.component';
import { ViewsService } from '../view/views.service';
import { NotificationsService } from 'src/app/notifications/notifications.service';

@Component({
  selector: 'app-topbar',
  templateUrl: 'topbar.component.html',
  styleUrls: ['topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  public itemsQuickMenu: any[];
  public searchResults: any[] = [];
  public searchText: string;

  public entity: any = null;
  public dropdownViews: any[] = [];
  public layout: any[] = [];

  public created_by: any;
  public user: any = {

  };
  public company: any = {};
  public companyCode;
  public items: any;
  public imageUrl = "assets/img/no-user.jpeg";
  public views_superadmin: boolean;
  public personalize_interface: boolean;
  public personalized_views_read: boolean;
  public personalized_views_write: boolean;
  public allowViewPersonalize: boolean = false;
  public allowedLayouts: any[] = [
    { code: "12", name: "1 columna (100%)" },
    { code: "6-6", name: "2 columnas (50%, 50%)" },
    { code: "8-4", name: "2 columnas (66%, 34%)" },
    { code: "9-3", name: "2 columnas (75%, 25%)" },
    { code: "4-8", name: "2 columnas (34%, 66%)" },
    { code: "3-9", name: "2 columnas (25%, 75%)" },
    { code: "4-4-4", name: "3 columnas (34%, 33%, 33%)" }
  ];

  //Correos entrantes pendientes:
  public totalNotificationsIn: number;
  public alerts: number;

  public viewOrig: any = {};
  public view: any = {};
  public selectedView: any;
  @Input("code") public code: string;
  @Output() onEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild("op") op: OverlayPanel;

  //@Input("model") public model: any = {};

  constructor(
    private searchService: SearchService,
    private loginService: LoginService,
    private usersService: UsersService,
    private attachmentsService: AttachmentsService,
    private attachmentsDataService: AttachmentsDataService,
    private coreDialogService: CoreDialogService,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private eventBus: NgEventBus,
    private viewsService: ViewsService,
    private entitiesService: EntitiesService,
    private configurationService: ConfigurationService,
    private notificationsService: NotificationsService,
  ) {

    //Recojo el identificador del usuario logeado:
    this.created_by = this.loginService.get("userId");
    this.loginService.onLoginStateChange.subscribe(authenticated => {
      if (authenticated) this.loadLoginData(authenticated)
    });

    this.router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        //ocultamos que se muestre personalización
        Promise.resolve(null).then(() => { this.allowViewPersonalize = false });
      }
    });
    this.viewsService.onViewChange.subscribe(
      data => {
        this.code = data;
        this.viewsService.getViewConfiguration(this.code).subscribe(
          data => {
            this.view = data;
            // this.viewOrig = JSON.parse(JSON.stringify(data));
            this.selectedView = this.view.id;
            this.loadViewsDropdown();
            //cargamos entidad base si tiene
            //if (this.view.configuration?.entity != null) this.loadBaseEntity();

            //si no hay layout, 1 columan
            //if (this.view.configuration?.layout == null) this.view.configuration.layout = "12";

            //preparamos layout
            //this.prepareLayout();

            //permitimos que se muestre personalización porque la pantalla tiene vistas, y porque no esta deshabilitada la personalización de ella
            if (this.view.configuration.personalizable != false) {
              Promise.resolve(null).then(() => { this.allowViewPersonalize = true });
            } else {
              Promise.resolve(null).then(() => { this.allowViewPersonalize = false });
            }
            //this.allowViewPersonalize = true;
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );
      });
  }

  ngOnInit(): void {
    this.itemsQuickMenu = [
      /* {
         label: 'Añadir contacto',
         icon: 'pi pi-user',
         //routerLink: this.addUser,
         command: (event) => { this.addContact(); },
         visible: this.loginService.hasPermission("CONTACTS_WRITE")
       },*/
      {
        label: 'Añadir organización',
        icon: 'pi pi-fw pi-briefcase',
        command: (event) => { this.addOrganization(); },
        visible: this.loginService.hasPermission("ORGANIZATIONS_WRITE"),
        value: 0
      },
      {
        label: 'Nuevo email',
        icon: 'pi pi-fw pi-envelope',
        command: (event) => { this.addEmail(); },
        visible: true,
        value: 0
      },
      {
        label: 'Nuevo informe',
        icon: 'pi pi-fw pi-copy',
        routerLink: ['reports/0'],
        visible: this.loginService.hasPermission("REPORTS_WRITE"),
        value: 0
      }, {
        label: 'Crear oportunidad',
        icon: 'pi pi-fw pi-money-bill',
        command: (event) => { this.addOportunity(); },
        visible: this.loginService.hasPermission("OPORTUNITIES_WRITE"),
        value: 0
      },
      {
        label: 'Crear actividad',
        icon: 'pi pi-fw pi-list',
        command: (event) => { this.addTask(); },
        visible: this.loginService.hasPermission("TASKS_WRITE"),
        value: 0
      },
      {
        label: 'Ver calendario',
        icon: 'pi pi-fw pi-calendar',
        routerLink: ['/calendar'],
        visible: this.loginService.hasPermission("CALENDAR"),
        value: 0
      },/*
      {
        label: 'Alertas',
        icon: 'pi pi-fw pi-bell',
        routerLink: ['/home'],
        visible: true,
        value: 1
      },*/
    ];
    this.loadNotificationsIn();
    this.loadLoginData(false);
    //this.loadLoginData(null);
    //this.loadOrganizations();
    this.items = [
      {
        label: 'Ver perfil',
        icon: 'pi pi-fw pi-user',
        command: (event) => { this.viewUser(); },
        //TODO: desconectar al usuario.
      },
      {
        label: 'Cambiar contraseña', command: (event) => { this.changePassword(); },
        icon: 'pi pi-fw pi-key',
        //event.originalEvent: Browser event
        //event.item: menuitem metadata
      },
      {
        label: 'Cerrar sesión',
        icon: 'pi pi-fw pi-sign-out',
        command: (event) => { this.logout(); },
        //TODO: desconectar al usuario.
      }
    ];
    this.personalize_interface = this.loginService.hasPermission("PERSONALIZE_INTERFACE");
    this.personalized_views_read = this.loginService.hasPermission("PERSONALIZED_VIEWS_READ");
    this.personalized_views_write = this.loginService.hasPermission("PERSONALIZED_VIEWS_WRITE");
    this.views_superadmin = this.loginService.hasPermission("VIEWS_SUPERADMIN") || localStorage.getItem("isSuperAdmin") == "true";
  }
  viewUser() {
    const ref = this.dialogService.open(UsersDetailComponent, {
      data: {
        id: localStorage.getItem("userId")
        //responsible_id: localStorage.getItem("userId")
      },
      //header: user ? "Detalles del usuario" : "Nuevo usuario",
      width: '70%',
    });
    ref.onClose.subscribe((data) => {
      //TODO: Recargar dropdown 
      //this.view.fireEvent("users.list.results", "reload");
    });
  }

  logout(): void {
    this.coreDialogService.confirm({
      message: "¿Está seguro que desea cerrar la sesión?",
      header: "",
      icon: "pi pi-info-circle",
      accept: () => {
        this.loginService.logout();
      },
      reject: () => { }
    });
  }
  changePassword() {
    const ref = this.dialogService.open(UserChangePasswordComponent, {
      data: {
        id: [localStorage.getItem("userId")]
      },
      header: "Cambiar contraseña",
      width: "40%",
      /*baseZIndex: 1000*/
    });
    ref.onClose.subscribe((data: any) => {
      if (data !== undefined) {
        //this.loadData(this.lastGridEvent);
      } else if (localStorage.getItem("forgotPassword") == "true") {
        //new_password pasa a ser password en caso de no llegar a hacer el cambio de contraseña:
        this.setNewPassword();
      }
    });
  }

  setNewPassword() {
    this.usersService.setNewPassword().subscribe(
      data => {
        localStorage.removeItem("forgotPassword");
        alert("La contraseña pasó a ser la contraseña de recuperación.");
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  filterSearch(event) {
    let query = event.query;
    //if (query.length >= 3) {
    this.searchService.all({ search_text: query }).subscribe(
      data => {
        this.searchResults = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    )
    //}
  }

  loadLoginData(authenticated) {
    this.user.id = localStorage.getItem("userId");
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.companyName = localStorage.getItem("companyName");
    //this.user.isSuperAdmin = localStorage.getItem("isSuperAdmin");
    this.companyCode = localStorage.getItem("companyCode");
    if (localStorage.getItem("forgotPassword") === "true") this.changePassword();

    this.loadCompanyInfo();
    this.loadProfile();
  }

  loadCompanyInfo() {
    this.configurationService.company().subscribe(
      data => {
        this.company = data;
        localStorage.setItem("is_template", data.is_template);
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    )
  }

  viewElementDetail(event) {
    this.searchText = "";
    if (event.entity_type == "contacts") {

      this.router.navigate(["/contacts/" + (event.id)]);
      /*
      const ref = this.dialogService.open(OrganizationsContactsDetailComponent, {
        data: {
          //id: this.organization.id,
          contactId: event.id
        },
        //header: "Detalles del contacto",
        width: '70%',
      });
      ref.onClose.subscribe((data: any) => {

      })*/
    } else if (event.entity_type == "tasks") {
      const ref = this.dialogService.open(TasksDetailComponent, {
        data: {
          //id:
          id: event.id
        },
        //header: "Detalles de la actividad",
        width: '70%',
      })
    } else {
      this.router.navigate(['/' + event.entity_type + '/', 0, event.id]);
    }
  }

  toogleMenu() {
    this.eventBus.cast('sidebar:toogle', null);
  }

  quickAddOrganization() {
    const ref = this.dialogService.open(OrganizationsQuickComponent, {
      data: {
        id: 0,
      },
      //header: "Nueva organización",
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
    })
  }

  loadProfile() {
    if (this.user.id && this.loginService.hasPermission("APP_LOGIN") && this.loginService.isLoggedIn()) {
      this.attachmentsDataService.getProfile({ entity_id: 18, entity_pk_id: this.user.id }).subscribe(
        data => {
          if (data != null && data['b64']) this.imageUrl = 'data:image/jpeg;base64,' + data['b64'];


        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
        }
      );
    }
  }

  loadBaseEntity() {
    this.entitiesService.getByCode(this.view.configuration.entity).subscribe(
      data => {
        this.entity = data;
        this.onEvent.emit({ component: "view", event: "entity-loaded", view: this.view, entity: this.entity });
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  prepareLayout() {
    let cols = this.view?.configuration?.layout.split("-");
    let nCol = 0;
    this.layout = [];
    cols.forEach(col => {
      this.layout.push({
        id: nCol,
        class: "p-md-" + col,
        components: this.getComponentsForColumn(nCol)
      });
      nCol++;
    });
    //this.onEvent.emit({ component: "view", event: "prepare-layout", view: this.view, entity: this.entity });
  }

  editViewClick(createNew) {
    this.viewsService.editView(this.code);
    this.op.hide();
  }
  newView() {
    this.viewsService.createView();
  }

  onLayoutChange(event) {
    let totalCols = this.view.configuration.layout.split("-").length;
    //si hay componentes sin col, los mandamos a la primera
    this.view.configuration.components.forEach(component => {
      if (component.layout_col != null && component.layout_col > totalCols - 1) component.layout_col = 0;
    });
    this.prepareLayout();
  }

  getComponentsForColumn(nCol: number) {
    let components = this.view?.configuration?.components.filter(m => {
      return m.layout_col == nCol || (nCol == 0 && m.layout_col == null);
    });
    return components;
  }
  loadViewsDropdown() {
    this.viewsService.viewsCombo({ code: this.code }).subscribe(
      data => {
        this.dropdownViews = data;
        /*if (this.personalized_views_write) {
          this.dropdownViews.push({ id: -1, name: "*** Crear nueva vista ***" });
        }*/
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }
  changeCurrentView() {
    //Éste método utilizará el id de la view seleccionada (selectedView) para guardarlo en el metadata del usuario (userId).
    if (this.selectedView != -1) {
      this.usersService.changeCurrentView(this.loginService.get("userId"), this.selectedView).subscribe(
        data => {
          if (data) {
            this.viewsService.removeViewConfigurationFromCache(this.selectedView.code);
            location.reload();
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  addOrganization() {
    const ref = this.dialogService.open(OrganizationsDetailGeneralComponent, {
      data: {
        id: 0,
        organization_type_id: null
      },
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      this.router.navigate(['/organizations/', data.organization_type_id ? data.organization_type_id : 0, data.id]);
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.usersService.visitedOrganizations(data.id).subscribe(data2 => {
        this.view.fireEvent("home.organization", "reload");
      },
        error => {
          console.log(error);
        });
    })
  }
  addEmail() {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        to: null,
        //template_type_id: 1,
        template_type_code: "MAIL",
        is_generic: true,
        searchRelated: true
        /*entity_id: 2,
        entity_pk_id: this.contact.id,
        organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
        template_type_id: 1*/
      },
      header: "Nuevo mensaje de correo",
      width: '70%',
    });
    ref.onClose.subscribe((data) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    });
  }
  addContact() {
    this.router.navigate(["/contacts/0"]);
    /*
    const ref = this.dialogService.open(OrganizationsContactsDetailComponent, {
      data: {
        contactId: 0,
      },
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    })
    */
  }
  addOportunity() {
    const ref = this.dialogService.open(TransactionsDetailComponent, {
      data: {
        id: 0,// opportunity ? opportunity.id : 0,
        organization_id: null,// this.organization.id,
        transaction_type_id: 1
      },
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      console.log("Data oport -> ", data);
      if (data != null) {
        this.router.navigate(['/transactions', data.transaction_type_id, data.id]);
      } else {
        this.view.fireEvent("home.opportunities", "reload");
        if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      }

    });
  }

  addTask() {
    const ref = this.dialogService.open(TasksDetailComponent, {
      data: {
        id: 0,
      },
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      if (data != null) {
        this.router.navigate(['/tasks/', (data.organization_id ? data.organization_id : 0), (data?.id ? data.id : 0)]);
      } else {
        this.view.fireEvent("home.tasks", "reload");
        if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      }

    })
  }

  call(item) {
    if (typeof item.routerLink != "undefined") {
      //window.location.replace(item.routerLink);
      this.router.navigate(item.routerLink);
    } else {
      item.command();
    }

  }

  loadNotificationsIn() {
    var params = {
      type: "in",
      status: "pending",
      allNotifications: true,
    }

    //Carga el número de correos entrantes que estén en estado pendiente:
    this.notificationsService.all(params).subscribe(
      data => {
        this.totalNotificationsIn = data.totalRows;
        var menuItem = this.itemsQuickMenu.find(m => m.label == "Alertas");
        if (menuItem == null) {
          this.itemsQuickMenu.push({
            label: 'Alertas',
            icon: 'pi pi-fw pi-bell',
            routerLink: ['notifications-in'],
            visible: true,
            value: this.totalNotificationsIn
          });
        } else {
          menuItem.value = this.totalNotificationsIn;
        }
      },
      error => {

      }
    );
    setTimeout(() => {
      this.loadNotificationsIn();
    }, 30 * 1000);
  }

}
